module.exports = __webpack_public_path__ + "img/notice-empty.ce98686c.png";